import React, { Component } from "react";
import {connect} from 'react-redux'
import FJResourcesElementAnimation from "../view/FJResourcesElementAnimation";
import styles from "../view/css/FJElementAnimationContainer.module.less";
import FJLocalStore from "../../../store/FJLocalStore";
import FJConfig from "../../../config/FJConfig";
import FJIntroOutroStore from "../../../store/FJIntroOutroStore";
import FJViewConstant from "../../../constant/FJViewConstant";
import {FJMediaAction} from "../../../redux/action/FJRoot.action";
import FJPanelAnimation from "../../../common/component/FJPanelAnimation/FJPanelAnimation";

class FJElementAnimationContainer extends Component{

	constructor(props) {
		super(props);

		this.resourceViewInfo = {
			width: 64,
			height: 64,
			space: 22,
			marginBottom: 20
		};

		this.classes = {
			textListClasses: {
				textListBox: ''
			},
			textMoreClasses: {
				textMoreBox: ''
			},
			pageHeaderClasses: {
				seeAllBox:styles.more_animation_box,
				titleBox: styles.text_animation_box,
				moreBox: styles.more_box,
			},
			pageHeaderBackClasses: {
				headerBox: styles.more_header_text,
				backBox: styles.back_more_back,
				titleBox: styles.more_title,
				backTextBox: styles.more_desc
			},
			itemClasses: {
        resourceItem: styles.item,
				resourceItemActive: styles.active,
				inner: styles.animation_inner_box,
				addBtnBox: '',
				deleteBtnBox: '',
				addBtn: '',
				name: '',
				link: '',
				refresh: '',
				reloadIcon: ''
			}
		}
	}

	_dealTextData = (showType) => {
		let {animationSlotPath, buildVersion,} = FJConfig;
		let {RESOURCES_ANIMATION_INTRO} = FJViewConstant;
		let allAnimations = showType === RESOURCES_ANIMATION_INTRO ?
      FJIntroOutroStore.animationInData : FJIntroOutroStore.animationOutData;
		let obj = {};

		allAnimations.forEach(item => {
		  let {category, list} = item;
      obj[FJLocalStore._(category)] = list.map(ani => {
        let {name, path} = ani;
        let result = {};
        result.name = name;
        result.title = FJLocalStore._(name);
        result.thumbnail = name === 'None' ? '' : `${animationSlotPath}${path}?v='${buildVersion}`;
        return result;
      });
    });

		return obj;
	};

	getItem = () => {
		let {RESOURCES_ANIMATION_INTRO, RESOURCES_ANIMATION_OUTRO} = FJViewConstant;

		let {
			isShow,
			onHandleClick,
			showType,
			chooseMediaIdList,
			introSelectedId,
			outroSelectedId,
		} = this.props;

		let config = {
			addIconToolTip: FJLocalStore._('add-to-timeline')
		};

		return [RESOURCES_ANIMATION_INTRO, RESOURCES_ANIMATION_OUTRO].map(type => {
			return (
				<FJResourcesElementAnimation classes={this.classes}
																		 key={type}
																		 allResourcesList={this._dealTextData(type)}
																		 resourceViewInfo={this.resourceViewInfo}
																		 config={config}
																		 isShow={isShow && type === showType}
																		 onHandleClick={onHandleClick}
																		 introSelectedId={introSelectedId}
																		 outroSelectedId={outroSelectedId}
																		 chooseMediaIdList={chooseMediaIdList}
																		 type={type}
				/>
			);
		})
	}

	render() {
		let {isShow, direction} = this.props
		return (
			<FJPanelAnimation active={isShow} direction={direction} render={this.getItem} />
    );

	}

}

const mapStateToProps = function (state) {
	return {
		showType: state.resource.showType,
		chooseMediaIdList: state.media.chooseMediaIdList,
    introSelectedId: state.media.introSelectedId,
    outroSelectedId: state.media.outroSelectedId,
	}
}

const mapDispatchToProps = function (dispatch) {
	return {
		onHandleClick: function (id) {
			dispatch(FJMediaAction.selectAnimationInOrOutAction(id));
		},
	}
}


export default connect(mapStateToProps, mapDispatchToProps)(FJElementAnimationContainer);
